import React from 'react';
import { IncotermsPostventaVista } from '../../vista/incotermsPostventaVista';
import { configuracionPostventaInicial } from '../../interfaces';
import { generarIdTemporal, useEdicionFilas, type ICoordinacionEdicionProps } from '../../../../globales/componentes/tabla/useEdicionFilas';
import type { IIncotermPostventa } from '../../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';

/** Catálogo de incoterms: se agregan, editan y eliminan fila por fila. */
export const IncotermsPostventaCV: React.FC<ICoordinacionEdicionProps> = (coordinacion) => {
    const incoterms = useEdicionFilas<IIncotermPostventa>({
        ...coordinacion,
        clave: 'incoterms',
        // TODO back: consultar el catálogo.
        datosIniciales: configuracionPostventaInicial.Incoterms,
        camposObligatorios: ['Codigo', 'Descripcion'],
        crearFila: () => ({ Id: generarIdTemporal(), Codigo: '', Descripcion: '' }),
        permiteEliminar: true
        // TODO back: alGuardarFila / alEliminarFila.
    });

    return <IncotermsPostventaVista incoterms={incoterms} />;
};
